import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { ApiService } from "../../../services/api.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import * as _ from "lodash";
import { ProductListComponent } from "../product-list/product-list.component";
import { MODAL_CONFIG } from "../../../services/constant";
import { TranslateService } from "@ngx-translate/core";
import { ProductDetail } from "../product.model";

@Component({
  selector: "product-list-detail",
  templateUrl: "./product-list-detail.component.html",
  styleUrls: ["./product-list-detail.component.scss"],
})
export class ProductListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  title = "";
  errorMessage: string = null;
  errorMsgForShow: string = null;
  errorMsgForShows: string = null;
  passwordPlaceHolder = "";
  parent: ProductListComponent = null;

  productId: string;
  productNameEng: string;
  productNameThai: string;
  departments: number[];
  departmentChoices = [];
  currentProduct: ProductDetail;

  @ViewChild("modalTemplate") modalTemplate: TemplateRef<any>;

  constructor(
    private apiService: ApiService,
    private modalService: BsModalService,
    private translate: TranslateService
  ) {}

  open(parent: ProductListComponent, selectedProduct: ProductDetail) {
    this.parent = parent;
    this.errorMessage = null;
    this.departmentChoices = this.parent.departmentChoices;

    if (selectedProduct) {
      this.currentProduct = selectedProduct;
      this.productId = selectedProduct.product_id;
      (this.productNameEng = selectedProduct.name_en),
        (this.productNameThai = selectedProduct.name_th),
        (this.departments = selectedProduct.departments || []);
      const name =
        this.currentLang === "th" ? this.productNameThai : this.productNameEng;
      this.title =
        this.translate.instant("PRODUCT.LIST.MODAL.TITLE") + " : " + name;
    } else {
      this.title = this.translate.instant("PRODUCT.LIST.MODAL.ADD-USER");
    }

    this.modalRef = this.modalService.show(this.modalTemplate, {
      backdrop: "static",
      class: "modal-dialog-centered"
    });
  }

  ngOnInit() {}

  submit() {
    if (this.currentLang === "th") {
      const errorField = [];
      this.errorMessage = null;

      if (!this.productId) {
        errorField.push("รหัสผลิตภัณฑ์");
      }

      if (!this.productNameEng || !this.productNameThai) {
        errorField.push("ชื่อผลิตภัณฑ์");
      }

      if (errorField.length > 0) {
        this.errorMessage = "โปรดกรอก " + errorField.join(", ") + " ให้ถูกต้อง";
        return;
      }
    } else {
      const errorField = [];
      this.errorMessage = null;

      if (!this.productId) {
        errorField.push("Product ID");
      }

      if (!this.productNameEng || !this.productNameThai) {
        errorField.push("Product name");
      }

      if (errorField.length > 0) {
        this.errorMessage =
          "Please fill " + errorField.join(", ") + " correctly";
        return;
      }
    }

    const payload = {
      product_id: this.productId,
      name_en: this.productNameEng,
      name_th: this.productNameThai,
      departments: this.departments || [],
    };

    const request$ = this.currentProduct
      ? this.apiService.updateProduct(this.currentProduct.id, payload)
      : this.apiService.createProduct(payload);

    request$.subscribe(
      () => {
        if (this.currentProduct) {
          this.sniff(
            "UPDATE_PRODUCT",
            this.productId + ":" + this.productNameEng
          );
        } else {
          this.sniff(
            "CREATE_PRODUCT",
            this.productId + ":" + this.productNameEng
          );
        }
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      (error) => {
        console.log(error);
        this.checkErrorMsg(error);
      }
    );
  }

  checkErrorMsg(error) {
    this.errorMessage = this.apiService.getErrorMessage(error);
  }

  clearData() {
    this.errorMessage = undefined;
    this.errorMsgForShows = undefined;
    this.productId = undefined;
    this.productNameEng = undefined;
    this.productNameThai = undefined;
    this.departments = [];
    this.currentProduct = undefined;
  }

  close() {
    this.modalRef.hide();
    this.clearData();
  }

  checkErrorAllMsg(error) {
    this.errorMsgForShows = this.apiService.getErrorMessage(error);
    if (this.translate.currentLang === "en") {
      this.errorMessage = this.errorMsgForShows[0];
    } else {
      this.errorMessage = this.errorMsgForShows[1];
    }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: "MANAGE_PRODUCT",
      target: target,
    };
    this.apiService.sniff(data).subscribe((res: any) => {});
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.ts